import { render, staticRenderFns } from "./QuickviewCompetitor.vue?vue&type=template&id=9d308234&scoped=true&"
import script from "./QuickviewCompetitor.vue?vue&type=script&lang=js&"
export * from "./QuickviewCompetitor.vue?vue&type=script&lang=js&"
import style0 from "./QuickviewCompetitor.vue?vue&type=style&index=0&id=9d308234&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d308234",
  null
  
)

export default component.exports